import React from 'react';
import moment from 'moment';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { fieldNames } from '../../../config';
import { getValidationRules } from './utils';

const EndDateField = ({
  initialValue,
  form,
  fieldProps,
  editMode,
  shutdown,
}) => {
  const init = initialValue ? moment(initialValue) : null;

  return (
    <Field
      fieldType={fieldTypes.rangePicker}
      form={form}
      name={fieldNames.endDate}
      label="Дата завершения (факт)"
      decoratorOptions={{
        rules: getValidationRules({
          initialValue: init,
          editMode,
          entity: editMode ? shutdown : form,
        }),
        initialValue: init,
      }}
      fieldProps={fieldProps}
    />
  );
};

export default EndDateField;
